import { useAddContentModal } from '@/features/events/components/AddContent/store';
import { useCustomizeMode } from '@/features/experiences/components/CustomizeMode';
import { usePageExperienceContext } from '@/features/experiences/contexts/PageExperienceContext';
import { useFeatureFlag } from '@/hooks/useFeatureFlag';
import { Button, Icon } from '@/ui';

export const AddButton = () => {
  const { value: plannerAddContentEnabled } = useFeatureFlag(
    'plannerAddContentEnabled'
  );
  const { readOnly } = usePageExperienceContext();
  const { open } = useAddContentModal();
  const { isCustomizeModeActive } = useCustomizeMode();

  if (readOnly || !plannerAddContentEnabled || isCustomizeModeActive) {
    return null;
  }

  return (
    <Button
      flexShrink={0}
      leftIcon={<Icon icon="Plus" size={4} />}
      size="ah"
      variant="ahDark"
      onClick={() => open()}
    >
      Add
    </Button>
  );
};
